import gitLogo from "../images/tech-stack-logos/git-logo.png";
import pythonLogo from "../images/tech-stack-logos/python-logo.png";
import anacondaLogo from "../images/tech-stack-logos/anaconda-logo.png";
import numpyLogo from "../images/tech-stack-logos/numPy-logo.png";
import pandasLogo from "../images/tech-stack-logos/pandas-logo.png";
import matplotlibLogo from "../images/tech-stack-logos/matplotlib-logo.png";
import seabornLogo from "../images/tech-stack-logos/seaborn-logo.png";
import plotlyLogo from "../images/tech-stack-logos/plotly-logo.png";
import scipySeekLogo from "../images/tech-stack-logos/scipy-seek-logo.png";
import postmanLogo from "../images/tech-stack-logos/postman-logo.png";
import flaskLogo from "../images/tech-stack-logos/flask-logo.png";
import mySQLLogo from "../images/tech-stack-logos/mySQL-logo.png";
import mongoDBLogo from "../images/tech-stack-logos/mongoDB-logo.png";
import apacheSparkLogo from "../images/tech-stack-logos/apache-spark-logo.png";
import dockerLogo from "../images/tech-stack-logos/docker-logo.png";
import kubernetesLogo from "../images/tech-stack-logos/kubernetes-logo.png";
import jenkinLogo from "../images/tech-stack-logos/jenkin-logo.png";
import circleCILogo from "../images/tech-stack-logos/circleCI-logo.png";
import githubActionLogo from "../images/tech-stack-logos/github-actions-logo.png";
import gitLabLogo from "../images/tech-stack-logos/gitlab-logo.png";
import scikitLearnLogo from "../images/tech-stack-logos/scikit-learn-logo.png";
import pytorchLogo from "../images/tech-stack-logos/pyTorch-logo.png";
import prometheusLogo from "../images/tech-stack-logos/prometheus-logo.png";
import grafanaLogo from "../images/tech-stack-logos/grafana-logo.png";
import powerBILogo from "../images/tech-stack-logos/power_BI_logo.png";
import html5Logo from "../images/tech-stack-logos/html5-logo.png";
import css3Logo from "../images/tech-stack-logos/css3-logo.png";
import javascriptLogo from "../images/tech-stack-logos/javaScript-logo.png";
import reactLogo from "../images/tech-stack-logos/react-logo.png";
import awsLogo from "../images/tech-stack-logos/aws-logo.png";
import fastAPILogo from "../images/tech-stack-logos/fastapi-logo.png";
import jupyterLabLogo from "../images/tech-stack-logos/jupyterLab-logo.png";
import lightGMBLogo from "../images/tech-stack-logos/lightGBM-logo.png";
import mlFlowLogo from "../images/tech-stack-logos/mlflow-logo.png";
import prefectLogo from "../images/tech-stack-logos/prefect-logo.png";
import redisLogo from "../images/tech-stack-logos/redis-logo.png";
import tableauLogo from "../images/tech-stack-logos/tableau-logo.png";

const techLogos = [
  { src: gitLogo, alt: "Git Logo", name: "Git" },
  { src: html5Logo, alt: "HTML5 Logo", name: "HTML5" },
  { src: css3Logo, alt: "CSS3 Logo", name: "CSS3" },
  { src: javascriptLogo, alt: "JavaScript Logo", name: "JavaScript" },
  { src: pythonLogo, alt: "Python Logo", name: "Python" },
  { src: anacondaLogo, alt: "Anaconda Logo", name: "Anaconda" },
  { src: jupyterLabLogo, alt: "Jupyter Lab Logo", name: "Jupyter Lab" },
  { src: numpyLogo, alt: "NumPy Logo", name: "NumPy" },
  { src: pandasLogo, alt: "Pandas Logo", name: "Pandas" },
  { src: matplotlibLogo, alt: "Matplotlib Logo", name: "Matplotlib" },
  { src: seabornLogo, alt: "Seaborn Logo", name: "Seaborn" },
  { src: scipySeekLogo, alt: "SciPy Logo", name: "SciPy" },
  { src: plotlyLogo, alt: "Plotly Logo", name: "Plotly" },
  { src: scikitLearnLogo, alt: "Scikit-Learn Logo", name: "Scikit-Learn" },
  { src: postmanLogo, alt: "Postman Logo", name: "Postman" },
  { src: flaskLogo, alt: "Flask Logo", name: "Flask" },
  { src: fastAPILogo, alt: "FastAPI Logo", name: "FastAPI" },
  { src: reactLogo, alt: "React Logo", name: "React" },
  { src: mySQLLogo, alt: "MySQL Logo", name: "MySQL" },
  { src: mongoDBLogo, alt: "MongoDB Logo", name: "MongoDB" },
  { src: apacheSparkLogo, alt: "Apache Spark Logo", name: "Apache Spark" },
  { src: dockerLogo, alt: "Docker Logo", name: "Docker" },
  { src: kubernetesLogo, alt: "Kubernetes Logo", name: "Kubernetes" },
  { src: jenkinLogo, alt: "Jenkins Logo", name: "Jenkins" },
  { src: circleCILogo, alt: "CircleCI Logo", name: "CircleCI" },
  { src: githubActionLogo, alt: "GitHub Actions Logo", name: "GitHub Actions" },
  { src: gitLabLogo, alt: "GitLab CI/CD Logo", name: "GitLab CI/CD" },
  { src: awsLogo, alt: "AWS Logo", name: "AWS" },
  { src: redisLogo, alt: "Redis Logo", name: "Redis" },
  { src: prefectLogo, alt: "Prefect Logo", name: "Prefect" },
  { src: mlFlowLogo, alt: "MLflow Logo", name: "MLflow" },
  { src: lightGMBLogo, alt: "LightGBM Logo", name: "LightGBM" },
  { src: pytorchLogo, alt: "PyTorch Logo", name: "PyTorch" },
  { src: prometheusLogo, alt: "Prometheus Logo", name: "Prometheus" },
  { src: grafanaLogo, alt: "Grafana Logo", name: "Grafana" },
  { src: powerBILogo, alt: "Power BI Logo", name: "Power BI" },
  { src: tableauLogo, alt: "Tableau Logo", name: "Tableau" },
];

export default techLogos;
